
import { ServiceData } from "@/types/home";
import { defineComponent, SetupContext, PropType } from "vue";
import ServiceListItem from "./ServiceListItem.vue";
export default defineComponent({
  components: { ServiceListItem },
  name: "ServiveList",
  props: {
    /**
     * 画像を表示するデータ配列
     */
    list: {
      type: Array as PropType<ServiceData[]>,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    /**
     * タグ押下を通知する
     */
    const selectUrlItem = (id: number, title: string, contentsUrl: string | null, externalContentsFlg: boolean) => {
      context.emit("on-click", id, title, contentsUrl, externalContentsFlg);
    };

    return {
      selectUrlItem
    };
  }
});
